/**
 * Method to display each process step in color based on the todo value.
 * status === null : No need to proceed | status === true : complete | status === false : in progress
 * intensity === true : Urgent | intensity === false : Normal
 *
 * Color meaning
 * secondary: grey, info: green, warning: orange, error: red
 **/
export const getTodoProgressColor = (todoList, key) => {
    const matchedItems = todoList.filter((item) => key.includes(item.todo_key));
    if (matchedItems.length === 0) return 'secondary'; // Set to the default value if no matching item is found.
    // If at least one status is 'FALSE' and at least intensity is 'TRUE', return to 'error'.
    if (matchedItems.some((item) => item.status === false) && matchedItems.some((item) => item.intensity === true)) {
        return 'error';
    }
    // If at least one status is 'FALSE' and all intensity values are 'FALSE', return to 'warning'.
    if (matchedItems.some((item) => item.status === false) && matchedItems.every((item) => item.intensity === false)) {
        return 'warning';
    }
    //If all status values are 'TRUE', return to 'info'.
    if (matchedItems.every((item) => item.status === true)) {
        return 'info';
    }
    if (matchedItems.some((item) => item.status === true) && matchedItems.some((item) => item.status === null)) {
        return 'info';
    }

    // default
    return 'secondary';
};

/**
 * Grid badge color from per-key card counts, with the same rules as getTodoProgressColor.
 * The badge turns red when a card is pending and a card is urgent, even if they are different cards.
 */
export const getTodoProgressSummaryColor = (summary, keys) => {
    const counts = keys.reduce((total, key) => {
        const group = summary?.[key];
        if (group) Object.keys(total).forEach((field) => { total[field] += group[field] ?? 0; });
        return total;
    }, { total: 0, pending: 0, urgent: 0, normal: 0, complete: 0, unset: 0 });
    if (!counts.total) return 'secondary';
    if (counts.pending && counts.urgent) return 'error';
    if (counts.pending && counts.normal === counts.total) return 'warning';
    if (counts.complete === counts.total || (counts.complete && counts.unset)) return 'info';
    return 'secondary';
};

export const getClassName = (todo, key, type = 'header') => {
    const matchedItems = todo.filter((item) => key.includes(item.todo_key));

    if (!matchedItems) return `disabled-${type}`; // Set to the default value if no matching item is found.

    if (
        matchedItems.length > 0 &&
        matchedItems.some((item) => item.status === false) &&
        matchedItems.every((item) => item.intensity === false)
    ) {
        return `processing-${type}`;
    }

    if (matchedItems.length > 0 && matchedItems.every((item) => item.status === true)) {
        return `complete-${type}`;
    }

    if (
        matchedItems.length > 0 &&
        matchedItems.some((item) => item.status === false) &&
        matchedItems.some((item) => item.intensity === true)
    ) {
        return `urgent-${type}`;
    }
    if (
        matchedItems.length > 0 &&
        matchedItems.some((item) => item.status === true) &&
        matchedItems.some((item) => item.status === null)
    ) {
        return `complete-${type}`;
    }
    // default
    return `disabled-${type}`;
};

export const getHeaderClass = (field, isHighlighted) => {
    if (field === false) return 'disabled-header';
    if (field) return isHighlighted;
};
